export const config: any = {
  apiUrl: 'https://api.sandbox.love',
  // apiUrl: 'http://localhost:8060',
};
